import { render, staticRenderFns } from "./ComplianceMonitoring.vue?vue&type=template&id=0bfa01aa&scoped=true&"
import script from "./ComplianceMonitoring.vue?vue&type=script&lang=js&"
export * from "./ComplianceMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceMonitoring.vue?vue&type=style&index=0&id=0bfa01aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa01aa",
  null
  
)

export default component.exports